import React from "react"
import { useHistory } from "react-router"
import BreadCrumb from "components/BreadCrumb"
import { PracticeSettingsRoutes } from "app/routes/types"
import routes from "app/routes"
import { HeaderWrapper, StyledTab, StyledTabs, StyledAppBar } from "./style"
import config from "./config"

const PracticeSettingsTabs = ({ id: tabId }: { id: PracticeSettingsRoutes }) => {
  const history = useHistory()
  const handleClick = (newTabId: PracticeSettingsRoutes) => {
    history.push(`/practice-settings/${newTabId}`)
  }
  return (
    <StyledAppBar color="primary" position="sticky" elevation={0}>
      <BreadCrumb routes={routes} />
      <HeaderWrapper>
        <StyledTabs value={tabId} TabIndicatorProps={{ className: "indicator" }}>
          {config.map(({ id, label }) => (
            <StyledTab key={id} label={label} value={id} selected={tabId === id} onClick={() => handleClick(id)} />
          ))}
        </StyledTabs>
      </HeaderWrapper>
    </StyledAppBar>
  )
}

export default PracticeSettingsTabs
